import { render, staticRenderFns } from "./Vertriebspartner.vue?vue&type=template&id=3fa98316&"
import script from "./Vertriebspartner.vue?vue&type=script&lang=js&"
export * from "./Vertriebspartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports